import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircle, ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Necesito experiencia previa?',
    answer: 'No, empezás desde cero.'
  }, {
    question: '¿Necesito muchas herramientas?',
    answer: 'No, aprendés qué usar y qué evitar.'
  }, {
    question: '¿Voy a poder generar ingresos?',
    answer: 'Ese es el objetivo: que lo lleves a la práctica.'
  }, {
    question: '¿Cómo accedo?',
    answer: 'Recibís todo el contenido de forma inmediata.'
  }];
  return <section className="py-20 px-4 bg-[#0a0a0a] pt-[0px] pb-[0px]" data-id="element-107">
      <div className="max-w-3xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-109">
          

          <h2 className="text-4xl md:text-5xl font-black" data-id="element-110">
            Preguntas <span className="text-brand-yellow" data-id="element-111">Frecuentes</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-112">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#1a1a1a] border border-gray-800 rounded-2xl overflow-hidden hover:border-brand-yellow/30 transition-colors" data-id="element-113">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left" data-id="element-114">
                <span className="text-xl font-bold text-white pr-4" data-id="element-115">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-brand-yellow flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-116" />
              </button>

              <AnimatePresence data-id="element-117">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-118">
                    <div className="px-6 pb-5 pt-2" data-id="element-119">
                      <p className="text-lg text-gray-300 leading-relaxed" data-id="element-120">
                        {faq.answer}
                      </p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}